/**
 * Where a run's Run Explorer page lives (task 1151). A Collaboration row is a
 * run, so the two ids are the same today; the route keeps both because task
 * 1150's run-detail read is addressed by both.
 */
export const runExplorerPath = (collaborationId: string, runId: string, turnIndex?: number | null): string =>
  `/collaborations/${collaborationId}/runs/${runId}${
    typeof turnIndex === 'number' && turnIndex >= 0 ? `?turn=${turnIndex}` : ''
  }`;

/**
 * Where a run of an AI Service lives (task 1306): the Run Explorer inside the
 * service's chrome. Every run link in the app that knows the run's AI Service
 * lands here, so there is one run page; `/collaborations/:id/runs/:id` is for a
 * run with no AI Service.
 */
export const serviceRunPath = (endpointId: string, collaborationId: string): string =>
  `/services/${endpointId}/runs/${collaborationId}`;

/** The AI Service page's Runs tab (task 1306). */
export const serviceRunsTabPath = (endpointId: string): string => `/services/${endpointId}?tab=runs`;
